import admin from './admin'
import users from './admin/users'
import contractors from './admin/contractors'
import crm from './crm'
import pm from './pm'
import settings from './settings'
import staffs from './staffs'
import user from './user'
import marketing from './marketing'
import recipients from './marketing/recipients'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    pm,
    crm,
    user,
    admin,
    users,
    staffs,
    settings,
    marketing,
    recipients,
    contractors,
  },
  state: {},
  mutations: {},
  actions: {},
})
